const cueSet2 = [
    {
          "duration": 0.142857,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 0,
          "time": 0,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.142857,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 7680,
          "time": 0.285714,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.142857,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 15360,
          "time": 0.571428,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.142857,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 23040,
          "time": 0.8571420000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.142857,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 30720,
          "time": 1.142856,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.142857,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 38400,
          "time": 1.4285700000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.142857,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 46080,
          "time": 1.7142840000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428569999999998,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 53760,
          "time": 1.9999980000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 61440,
          "time": 2.285712,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428569999999998,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 69120,
          "time": 2.571426,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 76800,
          "time": 2.8571400000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428569999999998,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 84480,
          "time": 3.1428540000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 92160,
          "time": 3.4285680000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428569999999998,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 99840,
          "time": 3.7142820000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 107520,
          "time": 3.9999960000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 115200,
          "time": 4.28571,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 122880,
          "time": 4.571424,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 130560,
          "time": 4.857138000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 138240,
          "time": 5.142852,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 145920,
          "time": 5.428566,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 153600,
          "time": 5.7142800000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 161280,
          "time": 5.999994000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 168960,
          "time": 6.2857080000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 176640,
          "time": 6.571422,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 184320,
          "time": 6.857136000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 89,
          "name": "F6",
          "ticks": 192000,
          "time": 7.142850000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 199680,
          "time": 7.428564000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000023,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 207360,
          "time": 7.714278,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 215040,
          "time": 7.999992000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 222720,
          "time": 8.285706000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 230400,
          "time": 8.57142,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 238080,
          "time": 8.857134,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 245760,
          "time": 9.142848,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 253440,
          "time": 9.428562000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 261120,
          "time": 9.714276000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 268800,
          "time": 9.99999,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 276480,
          "time": 10.285704,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 284160,
          "time": 10.571418000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 291840,
          "time": 10.857132,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 299520,
          "time": 11.142846,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 307200,
          "time": 11.428560000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 314880,
          "time": 11.714274000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 322560,
          "time": 11.999988000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 330240,
          "time": 12.285702,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 337920,
          "time": 12.571416000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 345600,
          "time": 12.857130000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 353280,
          "time": 13.142844,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 360960,
          "time": 13.428558,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 368640,
          "time": 13.714272000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 376320,
          "time": 13.999986000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 384000,
          "time": 14.285700000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 391680,
          "time": 14.571414,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 399360,
          "time": 14.857128000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 407040,
          "time": 15.142842000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 414720,
          "time": 15.428556,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000112,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 422400,
          "time": 15.71427,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 430080,
          "time": 15.999984000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 89,
          "name": "F6",
          "ticks": 437760,
          "time": 16.285698,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 445440,
          "time": 16.571412000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 453120,
          "time": 16.857126,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 460800,
          "time": 17.14284,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 468480,
          "time": 17.428554000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 476160,
          "time": 17.714268,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 483840,
          "time": 17.999982000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 491520,
          "time": 18.285696,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 499200,
          "time": 18.57141,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 506880,
          "time": 18.857124000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 514560,
          "time": 19.142838,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 522240,
          "time": 19.428552000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 529920,
          "time": 19.714266000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 537600,
          "time": 19.99998,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 545280,
          "time": 20.285694000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 552960,
          "time": 20.571408,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 560640,
          "time": 20.857122,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 568320,
          "time": 21.142836000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 576000,
          "time": 21.42855,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 583680,
          "time": 21.714264,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 591360,
          "time": 21.999978000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 599040,
          "time": 22.285692,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 606720,
          "time": 22.571406000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 614400,
          "time": 22.857120000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 622080,
          "time": 23.142834,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 629760,
          "time": 23.428548000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 637440,
          "time": 23.714262,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 645120,
          "time": 23.999976000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 652800,
          "time": 24.285690000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 660480,
          "time": 24.571404,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 668160,
          "time": 24.857118000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 675840,
          "time": 25.142832000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 89,
          "name": "F6",
          "ticks": 683520,
          "time": 25.428546,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 691200,
          "time": 25.714260000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 698880,
          "time": 25.999974,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 706560,
          "time": 26.285688,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 714240,
          "time": 26.571402000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 721920,
          "time": 26.857116,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 729600,
          "time": 27.142830000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 737280,
          "time": 27.428544000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 744960,
          "time": 27.714258,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 752640,
          "time": 27.999972000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 760320,
          "time": 28.285686000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 768000,
          "time": 28.571400000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 775680,
          "time": 28.857114000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 783360,
          "time": 29.142828,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 791040,
          "time": 29.428542000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 798720,
          "time": 29.714256000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 806400,
          "time": 29.99997,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 814080,
          "time": 30.285684000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 821760,
          "time": 30.571398000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1428570000000029,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 829440,
          "time": 30.857112,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 837120,
          "time": 31.142826000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 844800,
          "time": 31.42854,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 852480,
          "time": 31.714254000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 860160,
          "time": 31.999968000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 867840,
          "time": 32.285682,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 875520,
          "time": 32.571396,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 883200,
          "time": 32.857110000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 890880,
          "time": 33.142824000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 898560,
          "time": 33.428538,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 906240,
          "time": 33.714252,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 913920,
          "time": 33.999966,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 921600,
          "time": 34.28568,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 89,
          "name": "F6",
          "ticks": 929280,
          "time": 34.571394000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 936960,
          "time": 34.857108000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 944640,
          "time": 35.142822,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 952320,
          "time": 35.428536,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 960000,
          "time": 35.71425,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 967680,
          "time": 35.999964000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 975360,
          "time": 36.285678000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 983040,
          "time": 36.571392,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 990720,
          "time": 36.857106,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 998400,
          "time": 37.14282,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1006080,
          "time": 37.428534000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 1013760,
          "time": 37.714248000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1021440,
          "time": 37.999962000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 1029120,
          "time": 38.285676,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1036800,
          "time": 38.57139,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1044480,
          "time": 38.85710400000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 1052160,
          "time": 39.142818000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1059840,
          "time": 39.428532000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 1067520,
          "time": 39.714246,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1075200,
          "time": 39.99996,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 1082880,
          "time": 40.285674,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 1090560,
          "time": 40.571388000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1098240,
          "time": 40.857102000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1105920,
          "time": 41.142816,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1113600,
          "time": 41.42853,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1121280,
          "time": 41.714244,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1128960,
          "time": 41.99995800000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1136640,
          "time": 42.285672000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1144320,
          "time": 42.571386000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1152000,
          "time": 42.8571,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1159680,
          "time": 43.142814,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1167360,
          "time": 43.428528,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 89,
          "name": "F6",
          "ticks": 1175040,
          "time": 43.714242000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1182720,
          "time": 43.999956000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 1190400,
          "time": 44.28567,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1198080,
          "time": 44.571384,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 1205760,
          "time": 44.857098,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1213440,
          "time": 45.142812000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1221120,
          "time": 45.428526000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 1228800,
          "time": 45.714240000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1236480,
          "time": 45.999954,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 1244160,
          "time": 46.285668,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1251840,
          "time": 46.57138200000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 1259520,
          "time": 46.857096000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1267200,
          "time": 47.142810000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 79,
          "name": "G5",
          "ticks": 1274880,
          "time": 47.428524,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1282560,
          "time": 47.714238,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1290240,
          "time": 47.99995200000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 1297920,
          "time": 48.285666000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1305600,
          "time": 48.571380000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 1313280,
          "time": 48.857094000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1320960,
          "time": 49.142808,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 1328640,
          "time": 49.428522,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 1336320,
          "time": 49.71423600000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1344000,
          "time": 49.999950000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1351680,
          "time": 50.285664000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1359360,
          "time": 50.571378,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1367040,
          "time": 50.857092,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1374720,
          "time": 51.14280600000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1382400,
          "time": 51.428520000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1390080,
          "time": 51.714234000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1397760,
          "time": 51.999948,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1405440,
          "time": 52.285662,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1413120,
          "time": 52.571376,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 89,
          "name": "F6",
          "ticks": 1420800,
          "time": 52.85709000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 84,
          "name": "C6",
          "ticks": 1428480,
          "time": 53.142804000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 88,
          "name": "E6",
          "ticks": 1436160,
          "time": 53.428518000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1443840,
          "time": 53.714232,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285700000000645,
          "durationTicks": 3840,
          "midi": 86,
          "name": "D6",
          "ticks": 1451520,
          "time": 53.999946,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 81,
          "name": "A5",
          "ticks": 1459200,
          "time": 54.28566000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14285699999999935,
          "durationTicks": 3840,
          "midi": 83,
          "name": "B5",
          "ticks": 1466880,
          "time": 54.571374000000006,
          "velocity": 0.7874015748031497
        }
];

export default cueSet2;
